/**
 * Drop-in <Media /> that shows:
 *   - a real <img> if `src` is set
 *   - a looped <video> if `video` is set
 *   - an animated gradient placeholder with a label if neither
 *
 * Usage once you have the real file:
 *   import step1 from "../assets/plan-step-1.png";
 *   <Media src={step1} alt="Test results" />
 */
export function Media({
  src,
  video,
  label = "placeholder",
  alt,
  className = "",
  poster,
  rounded = "rounded-2xl",
}: {
  src?: string;
  video?: string;
  label?: string;
  alt?: string;
  className?: string;
  poster?: string;
  rounded?: string;
}) {
  if (video) {
    return (
      <video
        src={video}
        poster={poster}
        autoPlay
        loop
        muted
        playsInline
        className={`${rounded} w-full h-full object-cover ${className}`}
      />
    );
  }
  if (src) {
    return (
      <img
        src={src}
        alt={alt ?? label}
        className={`${rounded} w-full h-full object-cover ${className}`}
      />
    );
  }
  return (
    <div className={`${rounded} w-full h-full relative overflow-hidden placeholder-tile ${className}`}>
      <div className="absolute inset-0 video-placeholder opacity-70" />
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-[var(--color-forest-deep)]/70 text-xs tracking-widest uppercase bg-white/60 backdrop-blur px-3 py-1 rounded-full">
          {label}
        </span>
      </div>
    </div>
  );
}
